"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Str = void 0;
var Str = /** @class */ (function () {
    function Str() {
    }
    Str.random = function (length) {
        if (length === void 0) { length = 10; }
        return __spreadArrays(Array(length)).map(function () { return (~~(Math.random() * 36)).toString(36); })
            .join("");
    };
    Str.ucWords = function (text) {
        return text.toLowerCase().replace(/^([a-z])|\s+([a-z])/g, function ($1) {
            return $1.toUpperCase();
        });
    };
    Str.toSlug = function (text) {
        return text
            .toLowerCase()
            .replace(/[^a-z0-9 -]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, "");
    };
    Str.slugToWord = function (slug) {
        return slug
            .toLowerCase()
            .replace(/-+/g, " ")
            .replace(/^([a-z])|\s+([a-z])/g, function ($1) {
            return $1.toUpperCase();
        });
    };
    Str.toSnakeCase = function (text) {
        var toMap = text.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z][0-9]+/g);
        if (!toMap) {
            return "";
        }
        return toMap.map(function (c) { return c.toLowerCase(); }).join("_");
    };
    Str.snakeToWord = function (text) {
        var word = text.toLowerCase().replace(/_+/g, " ");
        return Str.ucWords(word);
    };
    return Str;
}());
exports.Str = Str;
